import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';

// Firebase callable requests automatically include the signed-in user's ID token.
// Keep this wrapper so the restored exchange modules do not need to know which
// authentication transport is in use.
export const withAdminSession = (data = {}) => ({ ...data });

export const adminCallable = (name) => {
  const call = httpsCallable(functions, name);
  return (data = {}) => call(data);
};
